<script setup lang="ts">
const app = useNuxtApp()
const kijidasConfig = useAppConfig().kijidas
const storeIndex = useStoreIndex()
const storeArticleList = useStoreArticleList()

definePageMeta({ layout: 'layout-side-default' })

const pageData = { items: [] as Article[] }

const setHead = () => {
  const headTitle = `テレビでミュージアム`
  const headDescription = `ミュージアムに関連するテレビ番組を紹介するページ。美術館・博物館だけでなく、デザインや建築、アーティストなどをテーマにした、様々な番組を取り上げます。`
  // ぱんくず作成
  storeIndex.setBreadCrumbs([
    {
      text: headTitle,
      disabled: false,
      to: { path: '/tv-museum' },
    },
  ])

  const headInput = app.$makeMeta({
    title: headTitle,
    description: headDescription,
  })
  useHead(headInput)
}

const isNewDateGroup = (index) => {
  const od = pageData.items[index].open_date
  if (!od) {
    return false
  } else if (index === 0) {
    return true
  } else {
    const odprev = pageData.items[index - 1].open_date
    if (odprev && odprev !== od) {
      return true
    }
  }
  return false
}

const initPage = async () => {
  const [_resSite, _resMaster, resList] = await Promise.all([
    storeIndex.fetchSite(),
    storeIndex.fetchMaster(),
    storeArticleList.fetchList('tvMuseumMain'),
  ])
  if (resList.code === 200000) {
    pageData.items = resList.data.articles as Article[]
  }
}
await initPage()
setHead()
</script>

<template>
  <div class="p-main">
    <h2 class="c-heading_page">
      テレビでミュージアム
    </h2>

    <div class="p-main_result">
      <div class="p-main_list">
        <div
          v-for="(item, index) in pageData.items"
          v-bind:key="item.id"
          class="c-tvmDayGroup"
        >
          <div
            v-if="isNewDateGroup(index)"
            class="c-tvmDayGroup_header"
          >
            {{ app.$getPeriodDayLabelForTvm(item.open_date) }}
          </div>
          <div
            class="c-tvmItem"
          >
            <div class="c-tvmItem_date">
              {{ item.custom.tv_time }}
            </div>
            <div class="c-tvmItem_title">
              {{ item.title }}
            </div>
            <div
              v-if="item.body_json"
              class="c-tvmItem_description"
              v-html="app.$getBody(item.body_json)"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@use "@/assets/css/foundation/mixin/responsive" as responsive;

.p-main {
  &_result {
    position: relative;
  }

  &_list {
    // margin: 55px -12px 0 0;
    margin: 40px -12px 0 0;
  }
}

.c-tvmDayGroup {
  margin-bottom: 33px;
  font-family: var(--g_font_family_NotoSansCJKjp);

  &_header {
    height: 42px;
    margin: 0 12px 0 0;
    padding: 4px 0 0 18px;
    background-color: var(--g_color_image_background_f1f4f6);
    font-family: var(--g_font_family_NotoSansCJKjp);
    font-size: 20px;
    font-weight: bold;
    line-height: 1.7;

    @include responsive.mq_down(sp) {
      font-size: 18px;
    }
  }
}

.c-tvmItem {
  display: flex;
  flex-direction: column;
  padding: 0 12px 0 3px;
  font-family: var(--g_font_family_NotoSansCJKjp);

  &_date {
    margin-top: 27px;
    color: var(--g_color_background_e4007f);
    font-size: 14px;
    font-weight: 500;
    line-height: 1.286;
  }

  &_title {
    margin-top: 2px;
    font-size: 20px;
    font-weight: bold;
    line-height: 1.6;

    @include responsive.mq_down(sp) {
      font-size: 18px;
    }
  }

  &_description {
    margin-top: 5px;
    font-size: 16px;
    font-weight: 400;
    line-height: 1.625;
  }

  &_tags {
    display: flex;
    flex-wrap: wrap;
    margin-top: -20px;
    padding: 13px 0 30px;

    &_item {
      min-width: 100px;
      margin-top: 20px;
      margin-right: 20px;
      color: var(--g_color_text_white);
      font-size: 14px;
      font-weight: bold;
      text-align: center;
    }
  }

  &_imageList {
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 29px;

    &_panel {
      width: 200px;
      margin: 25px 32px 0 0;

      &_img {
        height: 136px;
      }

      &_label {
        display: flex;
        justify-content: center;
        height: 22px;
        color: var(--g_color_text_white);
        font-family: var(--g_font_family_NotoSansCJKjp);
        font-size: 14px;
        font-weight: bold;
        line-height: 1.714;
      }
    }
  }
}
</style>
